import React from 'react';
import { motion } from 'framer-motion';

interface ParticleProps {
    index: number;
}

const Particle: React.FC<ParticleProps> = ({ index }) => {
    // Randomize initial positions and movement
    const randomX = Math.random() * 100 - 50; // -50 to 50
    const randomY = Math.random() * 100 - 50; 
    const randomDuration = 2 + Math.random() * 3;
    const randomDelay = Math.random() * 0.5;
    const size = 4 + Math.random() * 8;

    return (
        <motion.div
            initial={{ 
                x: 0, 
                y: 0, 
                opacity: 0, 
                scale: 0 
            }}
            animate={{ 
                x: randomX * 10, // Radiate outwards
                y: randomY * 10,
                opacity: [0, 0.8, 0], // Fade in and out
                scale: [0, 1.5, 0.5]
            }}
            transition={{ 
                duration: randomDuration,
                delay: randomDelay,
                ease: "easeOut",
                repeat: Infinity,
                repeatType: "loop"
            }}
            className="absolute rounded-full"
            style={{ 
                width: size,
                height: size,
                background: 'radial-gradient(circle, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0) 70%)',
                boxShadow: '0 0 15px 2px rgba(255,255,255,0.4)',
                filter: 'blur(1px)'
            }}
        />
    );
};

const CelebrationParticles: React.FC = () => {
    return (
        <div className="absolute inset-0 pointer-events-none flex items-center justify-center overflow-hidden">
            {/* Create 40-50 particles */}
            {Array.from({ length: 48 }).map((_, i) => (
                <Particle key={i} index={i} />
            ))}
        </div>
    );
};

export default CelebrationParticles;
